/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { getMeta } from "app/utils/meta";
import {
  Accordion,
  AccordionContext,
  AccordionItem,
  AccordionPanel,
} from "app/components/accordion";
import Link from "app/components/i18n/Link";
import Layout from "app/components/layout";
import { Fragment } from "react";

export const meta = () => {
  return getMeta({
    title: `Terms | Legal, acceptable use & prohibited activities`,
  });
};

const TermsAndConditions = () => {
  return (
    <Layout headerIsOnTop={false} enableHeaderShrinkingOnScroll={false}>
      <header className="bg-primary">
        <div className="zbooni-layout pb-7 sm:pb-9 pt-24 sm:pt-32">
          <h1 className="text-2xl font-extrabold text-white xs:text-[28px] sm:text-[32px]">
            Terms & Conditions
          </h1>
        </div>
      </header>
      <div className="bg-white text-sm sm:text-base py-8">
        <div className="zbooni-layout">
          <div className="flex flex-col gap-y-7">
            <div className="flex flex-col italic">
              <p>Effective Date on: July 30, 2023</p>
              <p>Last updated on: July 31, 2023</p>
            </div>
            <p>
              Please read these Terms and Conditions carefully before
              installing, accessing, using, or subscribing to our Services. By
              installing, accessing, using, or subscribing to our Services, you
              agree to these Terms and Conditions and policies referenced
              within, including but not limited to our Data Privacy Policy
              located at{" "}
              <Link to="/data-privacy-policy/" className="text-blue underline">
                https://www.zbooni.com/data-privacy-policy
              </Link>
              . If you install, access, use, or subscribe to the Services on
              behalf of a business, you represent to us that you have authority
              to bind that business or entity to these Terms and Conditions, and
              that business accepts these Terms and Conditions. If you do not
              agree to these Terms and Conditions or any policy referenced
              within, you may not use our Services.
            </p>
          </div>
          <Accordion active="definitions" scrollToDiv={true}>
            <AccordionContext.Consumer>
              {({ togglePanel }) => (
                <Fragment>
                  <AccordionItem
                    id="definitions"
                    className="flex justify-between h-[124px]"
                  >
                    <div className="flex items-center">
                      <p className="flex gap-x-3 sm:gap-x-6 text-lg font-extrabold sm:text-xl">
                        <span>1.</span>
                        <span>Definitions</span>
                      </p>
                    </div>
                  </AccordionItem>
                  <AccordionPanel id="definitions" className="border-b">
                    <div className="mb-10 flex flex-col gap-y-5">
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>1.1.</span>
                        <span>
                          “<span className="font-bold">Agreement</span>” means,
                          collectively, all the terms, conditions, notices, and
                          policies contained or referenced in this document (“
                          <span className="font-bold">
                            Terms and Conditions
                          </span>
                          ”) and all other operating rules, policies (including
                          the Data Privacy Policy, Payment Policy, and
                          Acceptable Use Policy) and procedures that we may
                          publish from time to time on the Website and/or the
                          Zbooni App. Our policies are available at{" "}
                          <a
                            className="text-blue underline cursor-pointer"
                            onClick={() => {
                              window.open(
                                "https://www.zbooni.com/data-privacy-policy",
                                "dataprivacypolicy"
                              );
                              window.open(
                                "https://www.zbooni.com/payment-policy",
                                "payment-policy"
                              );
                            }}
                          >
                            https://www.zbooni.com/policies
                          </a>
                          .
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>1.2.</span>
                        <span>
                          “<span className="font-bold">App Store Provider</span>
                          ” has the meaning ascribed to it under Clause 10.6.1
                          of these Terms and Conditions.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>1.3.</span>
                        <span>
                          “<span className="font-bold">Chargeback</span>” means
                          a request that a Customer files directly with his or
                          her Card company or Card issuing bank to invalidate a
                          processed payment.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>1.4.</span>
                        <span>
                          “<span className="font-bold">Claim</span>” means a
                          challenge to a payment that you or a Customer files
                          directly with Zbooni.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>1.5.</span>
                        <span>
                          “<span className="font-bold">Content</span>” means
                          contents of the Services, including its “look and
                          feel”, design, layout, editorial content, notices,
                          software, source code, images, illustrations,
                          animations, tools, text, ideas, communications,
                          replies, comments, graphics, interactive features,
                          designs, copyrights, trademarks, service marks,
                          branding, logos, and other similar assets, patents,
                          sounds, applications, and any intellectual property
                          therein, any of which may be generated, provided, or
                          otherwise made accessible on or through the Services.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>1.6.</span>
                        <span>
                          “<span className="font-bold">Customer</span>” means a
                          customer of the Merchant.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>1.7.</span>
                        <span>
                          “<span className="font-bold">Payment Processors</span>
                          ” means the third-party service providers offering
                          services as an agent of one or more financial
                          institutions in the Territories to process and settle
                          Transactions.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>1.8.</span>
                        <span>
                          “<span className="font-bold">Personal Data</span>” has
                          the meaning ascribed to it under the{" "}
                          <Link
                            to="/data-privacy-policy/"
                            className="text-blue underline"
                          >
                            Data Privacy Policy
                          </Link>
                          .
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>1.9.</span>
                        <span>
                          “<span className="font-bold">Reserve Account</span>”
                          has the meaning ascribed to it under{" "}
                          <a
                            onClick={() => {
                              togglePanel(
                                "processing-card-transactions-and-receiving-your-funds"
                              );
                              setTimeout(() => {
                                window.location.href = `#7-10-1`;
                              }, 150);
                            }}
                          >
                            Clause 7.10.1
                          </a>{" "}
                          of these Terms and Conditions.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>1.10.</span>
                        <span>
                          “<span className="font-bold">Reversal</span>” means
                          Zbooni reverses the settlement of funds from a
                          processed Transaction that you received because (a)
                          the card Transaction is invalidated by the card
                          issuer, (b) the settlement funds were sent to you in
                          error by (i) Zbooni, Payment Processor or local
                          financial institution; (ii) the processors, suppliers
                          or licensors of Zbooni; or (iii) any of the respective
                          affiliates, agents, directors, and employees of any of
                          the entities listed in (i) or (ii) above, (c) the
                          sender of the payment did not have authorization to
                          send the payment (for example the Customer used a card
                          that did not belong to the Customer), (d) you received
                          the payment for activities that violated this
                          Agreement, Payment Processor Terms, Payment Network
                          Rules, or applicable law, or (e) we decided a Claim
                          against you.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>1.11.</span>
                        <span>
                          “<span className="font-bold">Service</span>” means the
                          services offered by Zbooni to Merchants from time to
                          time, through Service Modules which include but are
                          not limited to (i) connected-commerce integration
                          through Zbooni’s proprietary software, (ii) hosting
                          products and services offered by Merchants to
                          Customers on the Zbooni Marketplace, (iii) the
                          processing and settlement of Transactions by Payment
                          Processors through Zbooni’s proprietary software
                          across platforms, and/or (iv) providing Merchants with
                          data-driven insights as set out on the Website and the
                          Zbooni App.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>1.12.</span>
                        <span>
                          “<span className="font-bold">Service Modules</span>”
                          means the subscription and package option of the
                          Service obtained by the Merchant, details of which are
                          set out in the Payment Policy located at{" "}
                          <Link
                            to="/payment-policy"
                            className="text-blue underline"
                          >
                            https://www.zbooni.com/payment-policy
                          </Link>
                          .
                        </span>
                      </p>
                      <div className="pl-6 sm:pl-10">
                        <p className="flex gap-x-5">
                          <span>1.13.</span>
                          <span>
                            “<span className="font-bold">Territory</span>”, and
                            “<span className="font-bold">Territories</span>”
                            means the Zbooni-covered territories listed below,
                            as may be updated from time to time.
                          </span>
                        </p>
                        <div className="mt-3 pl-11 sm:pl-14">
                          <p className="flex gap-x-5">
                            <span>1.13.1.</span>
                            <span>United Arab Emirates</span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>1.13.2.</span>
                            <span>Kingdom of Saudi Arabia</span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>1.13.3.</span>
                            <span>Jordan</span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>1.13.4.</span>
                            <span>Egypt</span>
                          </p>
                        </div>
                      </div>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>1.14.</span>
                        <span>
                          “<span className="font-bold">Transactions</span>”
                          means transactions between Merchants and their
                          Customers.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>1.15.</span>
                        <span>
                          “<span className="font-bold">Merchant</span>”, “
                          <span className="font-bold">you</span>”, and “
                          <span className="font-bold">your</span>” means the
                          sole proprietor or business organization, company, or
                          other entity registered as a ‘Merchant’ with Zbooni
                          pursuant to the Zbooni Account registration set out in
                          Clause 4 of these Terms and Conditions.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>1.16.</span>
                        <span>
                          “<span className="font-bold">Website</span>” means our
                          website located at{" "}
                          <Link to="/" className="text-blue underline">
                            https://www.zbooni.com
                          </Link>{" "}
                          and all Content and services provided by Zbooni at or
                          through the Website. Further, the term, “Website” also
                          refers to all Zbooni-owned subdomains of zbooni.com.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>1.17.</span>
                        <span>
                          “<span className="font-bold">Zbooni</span>”, “
                          <span className="font-bold">we</span>”, and “
                          <span className="font-bold">us</span>” means [Zbooni].
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>1.18.</span>
                        <span>
                          “<span className="font-bold">Zbooni Account</span>”
                          has its meaning ascribed to it under{" "}
                          <a
                            href="#4-1-2"
                            onClick={() => {
                              togglePanel("getting-a-zbooni-account");
                              setTimeout(() => {
                                window.location.href = `#4-1-2`;
                              }, 150);
                            }}
                          >
                            Clause 4.1.2
                          </a>{" "}
                          of these Terms and Conditions.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>1.19.</span>
                        <span>
                          “<span className="font-bold">Zbooni App</span>” means
                          the mobile application developed by Zbooni for
                          Merchants in connection with the Services.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>1.20.</span>
                        <span>
                          “
                          <span className="font-bold">
                            Zbooni Indemnified Parties
                          </span>
                          ” means Zbooni and its affiliates, and their
                          respective shareholders, directors, agents, officers,
                          personnel, employees, successors and assigns.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>1.21.</span>
                        <span>
                          “<span className="font-bold">Zbooni Marketplace</span>
                          ” means the Zbooni hosted commerce platform available
                          at{" "}
                          <a
                            href="https://cshop.market"
                            rel="noreferrer"
                            target="_blank"
                            className="text-blue underline"
                          >
                            https://cshop.market
                          </a>{" "}
                          and any associated websites, products, or services
                          offered by Zbooni.
                        </span>
                      </p>
                    </div>
                  </AccordionPanel>
                  <AccordionItem
                    id="who-we-are-and-how-to-contact-us"
                    className="flex justify-between h-[124px]"
                  >
                    <div className="flex items-center">
                      <p className="flex gap-x-3 sm:gap-x-6 text-lg font-extrabold sm:text-xl">
                        <span>2.</span>
                        <span>Who We Are and How to Contact Us</span>
                      </p>
                    </div>
                  </AccordionItem>
                  <AccordionPanel
                    id="who-we-are-and-how-to-contact-us"
                    className="border-b"
                  >
                    <div className="mb-10 flex flex-col gap-y-5">
                      <div className="pl-6 sm:pl-10">
                        <p className="flex gap-x-5">
                          <span>2.1.</span>
                          <span>
                            The Website, Zbooni App, and the Services are owned
                            and operated by Zbooni DMCC, Mazaya Business Avenue
                            AA1, Office 3205, Jumeria Lake Towers, Dubai, United
                            Arab Emirates, +971 4 5579133.
                          </span>
                        </p>
                        <div className="mt-3 pl-6 sm:pl-10">
                          <p className="flex gap-x-5">
                            <span>2.1.1.</span>
                            <span>
                              Zabooni Arab Company for Information Technology
                              located at Al-Yasmeen, Abu Bakr Al Siddiq 13532,
                              Riyadh, Kingdom of Saudi Arabia, +966 56 395 8809
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>2.1.2.</span>
                            <span>
                              Zbooni Jordan for Marketing and e-commerce LLC
                              located at King Hussein Business Park, Building No
                              7, V Business Center, Office 304, Amman, Jordan,
                              +962 7 9111 1868
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>2.1.3.</span>
                            <span>
                              Zbooni Egypt located at 8 Hafez Ibrahim St, City
                              Center Mall, CO 55, Cairo, Egypt, +201 100 484
                              7171
                            </span>
                          </p>
                        </div>
                      </div>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>2.2.</span>
                        <span>
                          If you have any questions regarding the Service or the
                          Agreement, please feel free to contact us at{" "}
                          <a
                            className="text-blue underline"
                            href="mailto:hello@zbooni.com"
                            lang="en"
                          >
                            hello@zbooni.com
                          </a>
                          .
                        </span>
                      </p>
                    </div>
                  </AccordionPanel>
                  <AccordionItem
                    id="applicable-terms-and-consent"
                    className="flex justify-between h-[124px]"
                  >
                    <div className="flex items-center">
                      <p className="flex gap-x-3 sm:gap-x-6 text-lg font-extrabold sm:text-xl">
                        <span>3.</span>
                        <span>Applicable Terms and Consent</span>
                      </p>
                    </div>
                  </AccordionItem>
                  <AccordionPanel
                    id="applicable-terms-and-consent"
                    className="border-b"
                  >
                    <div className="mb-10 flex flex-col gap-y-5">
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>3.1.</span>
                        <span>
                          By installing, accessing, using, or subscribing to any
                          of our Services, you confirm that you accept and agree
                          that you will comply with these Terms and Conditions,
                          and all other terms set out in the Agreement. If you
                          do not agree to any of these Terms and Conditions or
                          any other terms set out in the Agreement, you must not
                          use any of the Services.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>3.2.</span>
                        <span>
                          If you use the Services, whether in part or whole, on
                          behalf of another person, you represent and warrant
                          that you are legally and duly authorized and empowered
                          by and for such person to agree to (i) this Agreement
                          on behalf of such person and (ii) use the Services on
                          behalf of such person. Further, you acknowledge and
                          agree that you shall indemnify, on demand, the Zbooni
                          Indemnified Parties for any breach of such
                          representation and warranty.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>3.3.</span>
                        <span>
                          For more information regarding our various policies,
                          please refer to{" "}
                          <a
                            className="text-blue underline cursor-pointer"
                            onClick={() => {
                              window.open(
                                "https://www.zbooni.com/data-privacy-policy",
                                "dataprivacypolicy"
                              );
                              window.open(
                                "https://www.zbooni.com/payment-policy",
                                "payment-policy"
                              );
                            }}
                          >
                            https://www.zbooni.com/policies
                          </a>
                          .
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>3.4.</span>
                        <span>
                          Further, we reserve the right to change, in our sole
                          discretion, the Terms and Conditions and other terms
                          in the Agreement at any time by publishing the varied
                          terms on the Website, with or without notice. If a
                          material change is made, we will provide reasonable
                          notice by email at your email address registered with
                          your Zbooni Account or notification of such change to
                          the Zbooni Account.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>3.5.</span>
                        <span>
                          You are responsible for reviewing regularly
                          information posted online to obtain timely notice of
                          such changes. As such, we recommend that you check the
                          Website and your Zbooni Account regularly to ensure
                          you are aware of our current terms. We do not
                          undertake to keep our Website up-to-date and we are
                          not liable if any content is inaccurate or
                          out-of-date. Your continued use of any part of the
                          Services after changes are posted constitutes your
                          acceptance of the Agreement as modified by the posted
                          changes.
                        </span>
                      </p>
                    </div>
                  </AccordionPanel>
                  <AccordionItem
                    id="getting-a-zbooni-account"
                    className="flex justify-between h-[124px]"
                  >
                    <div className="flex items-center">
                      <p className="flex gap-x-3 sm:gap-x-6 text-lg font-extrabold sm:text-xl">
                        <span>4.</span>
                        <span>Getting a Zbooni Account</span>
                      </p>
                    </div>
                  </AccordionItem>
                  <AccordionPanel
                    id="getting-a-zbooni-account"
                    className="border-b"
                  >
                    <div className="mb-10 flex flex-col gap-y-5">
                      <div className="pl-6 sm:pl-10">
                        <p className="flex gap-x-5">
                          <span>4.1.</span>
                          <span className="underline">Registration</span>
                        </p>
                        <div className="flex flex-col gap-y-5 mt-3 pl-8 sm:pl-12">
                          <p className="flex gap-x-5">
                            <span>4.1.1.</span>
                            <span>
                              The Service is only made available to persons in
                              the Territories that operate a business activity,
                              selling goods and services. You agree and
                              acknowledge that the Service is not made available
                              for any personal, family, or household purposes.
                            </span>
                          </p>
                          <p id="4-1-2" className="flex gap-x-5 scroll-mt-20">
                            <span>4.1.2.</span>
                            <span>
                              To use the Service for your business, you will
                              first have to register for an account (“
                              <span className="font-bold">Zbooni Account</span>
                              ”). You may choose to register as an individual
                              (sole proprietor) or as a company or other
                              business organization.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>4.1.3.</span>
                            <span>
                              If you register as a business organization,
                              company, or other legal entity (“
                              <span className="font-bold">Entity</span>”), you
                              must also provide information about an owner or
                              principal of the Entity, and you must be
                              authorized to act on behalf of the Entity and have
                              the authority to bind the business to the
                              Agreement. Accordingly, you represent and warrant
                              that you are legally and duly authorized and
                              empowered by such Entity to (i) this Agreement on
                              behalf of such Entity, and (ii) use the Services
                              on behalf of such Entity. Further, you acknowledge
                              and agree that you shall indemnify, on demand, the
                              Zbooni Indemnified Parties for any breach of such
                              representation and warranty.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>4.1.4.</span>
                            <span>
                              If you register as an individual, you must be at
                              least the age of majority in the jurisdiction
                              where you reside or where you carry out business
                              activities, whichever is higher.
                            </span>
                          </p>
                        </div>
                      </div>
                      <div className="pl-6 sm:pl-10">
                        <p className="flex gap-x-5">
                          <span>4.2.</span>
                          <span className="underline">
                            Verification and Underwriting
                          </span>
                        </p>
                        <div className="flex flex-col gap-y-5 mt-3 pl-8 sm:pl-12">
                          <p className="flex gap-x-5">
                            <span>4.2.1.</span>
                            <span>
                              When you register for a Zbooni Account, you must
                              provide us with accurate and complete information
                              as prompted by the registration process including
                              but not limited to basic information including
                              your name, company name, location, email address,
                              and phone number.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>4.2.2.</span>
                            <span>
                              Further, to verify your identity, we may, in our
                              sole and absolute discretion, take measures, from
                              time to time, to verify, re-verify or validate
                              your identity and you hereby authorize us to make
                              any inquiries at any time we deem desirable,
                              necessary or expedient to verify your identity and
                              assess whether you meet, or continue to meet our
                              eligibility requirements for using the Service
                              and/or creating a Zbooni Account, including but
                              not limited to (i) asking you for further
                              information including but not limited to your date
                              of birth, government-issued ID, tax identification
                              number, commercial license, financial statements,
                              business invoices, reseller authorization,
                              distributor information, and other forms of
                              identification such as a driver’s license, (ii)
                              requesting to do a physical inspection at your
                              place of business and to examine books and records
                              that pertain to your compliance with this
                              Agreement, and/or (iii) verifying information you
                              provide against third party databases or through
                              other sources (collectively, “Verification
                              Tools”). If you do not provide such information,
                              take such required steps, or otherwise fail to
                              comply with any of the foregoing requirements, or
                              if we cannot verify your identity, we reserve the
                              right, in our sole and absolute discretion, to
                              delay registering your Zbooni Account, refuse
                              access to the Service, suspend, and/or terminate
                              your Zbooni Account.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>4.2.3.</span>
                            <span>
                              Further, you expressly agree, acknowledge, and
                              authorize us to retrieve information about you by
                              using third parties, including credit bureaus and
                              other information providers. You acknowledge that
                              such information retrieved may include your name,
                              address history, credit history, and other data
                              about you. We may periodically update this
                              information to determine whether you continue to
                              meet the eligibility requirements for a Zbooni
                              Account.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>4.2.4.</span>
                            <span>
                              After we have collected and verified all your
                              information, Zbooni will, in its sole and absolute
                              discretion, determine if you are eligible to use
                              the Service. You expressly agree and acknowledge
                              that Zbooni may also share your information with
                              our Payment Processors and local financial
                              institutions, each of which may also decide
                              regarding your eligibility. We will notify you at
                              your email address provided to us during the
                              registration process once your Zbooni Account has
                              been either approved or deemed ineligible for use
                              of the Service.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>4.2.5.</span>
                            <span>
                              You agree that Zbooni is permitted to contact and
                              share information about you and your application
                              (including whether you are approved or declined),
                              and your Zbooni Account with the Payment
                              Processor, including local financial institutions.
                              This includes sharing information (i) about your
                              Transactions for regulatory or compliance
                              purposes, (ii) for use in connection with the
                              management and maintenance of the Service, (iii)
                              to create and update their customer records about
                              you and to assist them in better serving you, and
                              (iv) to conduct Zbooni&apos;s risk management
                              process.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>4.2.6.</span>
                            <span>
                              Further, you expressly authorize us to contact
                              your Customers from time to time to validate and
                              verify Transactions.
                            </span>
                          </p>
                        </div>
                      </div>
                      <div className="pl-6 sm:pl-10">
                        <p className="flex gap-x-5">
                          <span>4.3.</span>
                          <span className="underline">
                            Continous Verification
                          </span>
                        </p>
                        <div className="flex flex-col gap-y-5 mt-3 pl-8 sm:pl-12">
                          <p className="flex gap-x-5">
                            <span>4.3.1.</span>
                            <span>
                              You understand, agree and acknowledge that Zbooni
                              continuously verifies you and your Zbooni Account
                              pursuant to our own proprietary risk assessment
                              tools. Accordingly, from time-to-time, and
                              depending on our own risk and verification
                              metrics, we may, in our sole and absolute
                              discretion, take measures from time to time to
                              re-verify or re-validate your identity and assess
                              whether you meet, or continue to meet our
                              eligibility requirements for using the Service
                              and/or creating a Zbooni Account. Such measures
                              may include (i) Verification Tools, (ii)
                              contacting your Customers to validate and verify
                              Transactions, and/or (iii) any other means we deem
                              appropriate in accordance with applicable law. If
                              you do not provide such information, take such
                              required steps, or otherwise fail to comply with
                              any of the foregoing requirements, or if we cannot
                              verify your identity, we reserve the right, in our
                              sole and absolute discretion, to refuse access to
                              the Service, suspend, and/or terminate your Zbooni
                              Account.
                            </span>
                          </p>
                        </div>
                      </div>
                      <div className="pl-6 sm:pl-10">
                        <p className="flex gap-x-5">
                          <span>4.4.</span>
                          <span className="underline">Zbooni Account</span>
                        </p>
                        <div className="flex flex-col gap-y-5 mt-3 pl-8 sm:pl-12">
                          <p className="flex gap-x-5">
                            <span>4.4.1.</span>
                            <span>
                              We may allow you to log in to the Zbooni Account
                              through various online third-party services, such
                              as social media and social networking services
                              like Google or Facebook (“
                              <span className="font-bold">
                                Third Party Services
                              </span>
                              ”). To use these features and capabilities, we may
                              ask you to authenticate, register for, or log into
                              Third Party Services on the websites of their
                              respective providers. As part of this integration,
                              the Third Party Services will provide us with
                              access to certain information you have provided to
                              them, and we will use, store, and disclose such
                              information in accordance with our Data Privacy
                              Policy located at{" "}
                              <Link
                                to="/data-privacy-policy/"
                                className="text-blue underline"
                              >
                                https://www.zbooni.com/data-privacy-policy
                              </Link>
                              .
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>4.4.2.</span>
                            <span>
                              Third Party Services use, store, and disclose your
                              information solely in accordance with their
                              policies. We assume no responsibility or liability
                              for the privacy practices or any other actions of
                              any third-party website or service that may be
                              enabled within the Services. Further, we assume no
                              responsibility or liability for any damage or loss
                              caused or alleged to be caused by or in connection
                              with the use of or reliance on any such Third
                              Party Services.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>4.4.3.</span>
                            <span>
                              You represent and warrant that you are the
                              subscriber and owner of the email address you
                              provided in connection with the Services and
                              Zbooni Account. Further, you agree and acknowledge
                              that we or our affiliates may contact you by
                              e-mail to your provided email address to provide
                              you with notices and information regarding your
                              Zbooni Account or use of the Services, fulfill
                              your requests, resolve your complaints, provide
                              you with promotional information, or for any other
                              purpose we deem necessary in our sole and absolute
                              discretion. However, regarding promotional
                              information and other non-essential information,
                              as determined by us in our sole discretion, you
                              may opt out any time by following the steps set
                              out in the e-mails we may send you to your
                              provided email address. Please note that we are
                              not liable for any delayed or undelivered emails.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>4.4.4.</span>
                            <span>
                              You acknowledge and agree that Zbooni may provide
                              disclosures and notices, including tax forms,
                              regarding the Service to you by posting such
                              disclosures and notices on our Website, emailing
                              them to the email address listed in your Zbooni
                              Account, or mailing them to the address listed in
                              your Zbooni Account. You also agree that
                              electronic disclosures and notices have the same
                              meaning and effect as if we had provided you with
                              a hard-paper copy. Such disclosures and notices
                              shall be considered to be received by you within
                              24 hours of the time it is posted to the Website
                              or e-mailed to you at your provided e-mail
                              address.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>4.4.5.</span>
                            <span>
                              You agree and consent to receive all notices and
                              information we may send to your provided e-mail
                              address. It is your responsibility to provide us
                              with your complete, accurate contact information,
                              or promptly update us in the event you change your
                              information. If we discover that any information
                              provided in connection with your account is false
                              or inaccurate, we reserve the right, in our sole
                              and absolute discretion, to suspend or terminate
                              your account at any time.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>4.4.6.</span>
                            <span>
                              You are responsible for maintaining the
                              confidentiality of all actions that take place
                              while using the Services and your Zbooni Account,
                              and must notify us immediately at{" "}
                              <a
                                className="text-blue underline"
                                href="mailto:hello@zbooni.com"
                                lang="en"
                              >
                                hello@zbooni.com
                              </a>{" "}
                              in the event of any actual or suspected loss or
                              unauthorized use of your Zbooni Account. We are
                              not responsible, and we do not assume any
                              liability for any loss that results from
                              unauthorized use of your Zbooni Account.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>4.4.7.</span>
                            <span>
                              Please note that transmission of data or
                              information including but not limited to
                              communications by e-mail over the internet or
                              other networks is not completely secure, and may
                              result in possible loss, interception, or
                              alteration. Accordingly, we do not assume any
                              responsibility or liability for any damage or
                              costs you may incur as a result of any such
                              transmissions over the internet or other networks.
                              While we shall take commercially reasonable
                              efforts to protect the privacy of all information
                              you provide us and while we shall treat all such
                              information in accordance with our Data Privacy
                              Policy, in no event will the information you
                              provide to us create any fiduciary duty or
                              obligations to you, or result in any liability to
                              you if such information is accessed by third
                              parties without our express written consent.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>4.4.8.</span>
                            <span>
                              If you want to end your relationship with Zbooni
                              and close your Zbooni Account and disable access
                              to the Services, you can do so by contacting us at{" "}
                              <a
                                className="text-blue underline"
                                href="mailto:hello@zbooni.com"
                                lang="en"
                              >
                                hello@zbooni.com
                              </a>
                              . For further information regarding the removal of
                              data, please refer to the Data Privacy Policy.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>4.4.9.</span>
                            <span>
                              Use of the Services may be available through the
                              Zbooni App, which may not be available or
                              compatible for all devices. You agree that you are
                              solely responsible for these requirements,
                              including any applicable changes, updates and fees
                              (including message and data rates) as well as the
                              terms of your agreement with your mobile device
                              and telecommunications provider. You will need to
                              check the Services to ensure your device and
                              telecommunications provider are compatible. Zbooni
                              is not obligated to provide a compatible version
                              of the Services (including but not limited to a
                              compatible mobile app) for all devices, operating
                              systems or telecommunication providers, all of
                              which are subject to change by Zbooni at any time
                              without notice to you.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>4.4.10.</span>
                            <span>
                              Please note that if you wish to remove the Zbooni
                              App from your mobile devices, then you may delete
                              the Zbooni App, however that will only delete your
                              data from the device. Your content is subject to
                              this Agreement and will be treated in accordance
                              with applicable law.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>4.4.11.</span>
                            <span>
                              We reserve the right to refuse to provide the
                              Services to anyone and can monitor, terminate or
                              suspend your Zbooni Account or access to the
                              Services at any time.
                            </span>
                          </p>
                          <div>
                            <p className="flex gap-x-5">
                              <span>4.4.12.</span>
                              <span>
                                We may, in our sole discretion, also deactivate,
                                terminate, or suspend your Zbooni Account or
                                access to any and all Services at any time:
                              </span>
                            </p>
                            <ol className="flex flex-col gap-y-3 mt-3 roman pl-14 sm:pl-16">
                              <li>
                                if we determine you are or have been in
                                violation of the Agreement or applicable
                                law,{" "}
                              </li>
                              <li>
                                in response to requests by law enforcement or
                                other applicable authority, or
                              </li>
                              <li>
                                upon discontinuation or material modification of
                                any Services.
                              </li>
                            </ol>
                          </div>
                        </div>
                      </div>
                    </div>
                  </AccordionPanel>
                  <AccordionItem
                    id="services"
                    className="flex justify-between h-[124px]"
                  >
                    <div className="flex items-center">
                      <p className="flex gap-x-3 sm:gap-x-6 text-lg font-extrabold sm:text-xl">
                        <span>5.</span>
                        <span>Services</span>
                      </p>
                    </div>
                  </AccordionItem>
                  <AccordionPanel id="services" className="border-b">
                    <div className="mb-10 flex flex-col gap-y-5">
                      <div className="pl-6 sm:pl-10">
                        <p className="flex gap-x-5">
                          <span>5.1.</span>
                          <span className="underline">Our Software</span>
                        </p>
                        <div className="flex flex-col gap-y-5 mt-3 pl-8 sm:pl-12">
                          <p className="flex gap-x-5">
                            <span>5.1.1.</span>
                            <span>
                              Zbooni provides the commerce software to enable
                              you to use the Service. We reserve the right to
                              require you to install or update any and all
                              software updates to continue using the Service.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>5.1.2.</span>
                            <span>
                              We may update or amend our Services from time to
                              time, in our sole and absolute discretion.
                              Therefore, we may provide updates (including
                              automatic updates) for certain Services from time
                              to time. This may include upgrades, modifications,
                              bug fixes, patches, other error corrections, or
                              new features. You may be required to download and
                              install such updates from time to time to ensure
                              that your Zbooni Account and the Services function
                              properly. Further, you hereby expressly consent to
                              automatic updates and agree that the Terms and
                              Conditions and other terms of the Agreement will
                              apply to all such updates to the Services.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>5.1.3.</span>
                            <span>
                              In our sole discretion, we may change, suspend, or
                              discontinue any or all of the Services at any
                              time. In addition, we have no obligation to
                              provide any updates or to continue to provide or
                              enable any particular features or functionality of
                              any Service. We may also impose limits on certain
                              Services or restrict your access to part or all of
                              the Services without notice or liability.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>5.1.4.</span>
                            <span>
                              We do not warrant that the Services will be
                              compatible with your mobile device or carrier.
                              Your use of the Services may be subject to the
                              terms of your agreements with your mobile device
                              manufacturer or your carrier. You may not use a
                              modified device to use the Services if the
                              modification is contrary to the manufacturer’s
                              software or hardware guidelines, including
                              disabling hardware or software controls.
                            </span>
                          </p>
                        </div>
                      </div>
                      <div className="pl-6 sm:pl-10">
                        <p className="flex gap-x-5">
                          <span>5.2.</span>
                          <span className="underline">Payment Processor</span>
                        </p>
                        <div className="flex flex-col gap-y-5 mt-3 pl-8 sm:pl-12">
                          <p className="flex gap-x-5">
                            <span>5.2.1.</span>
                            <span>
                              The Payment Processor is a technical service
                              provider and may offer the services as an agent of
                              one or more financial institutions in the
                              operating countries. The processing and settlement
                              of your Transactions are carried out by the
                              Payment Processor. The Payment Processor’s role is
                              to accept and process credit cards, debit cards,
                              and other types of payments (collectively “
                              <span className="font-bold">Cards</span>”) with
                              respect to sales of your products and services
                              through Transactions.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>5.2.2.</span>
                            <span>
                              Depending on the Service Module and Services
                              provided to the Merchant, we use specific Payment
                              Processors, details of whom can be found in the
                              Payment Policy located at{" "}
                              <Link
                                to="/payment-policy"
                                className="text-blue underline"
                              >
                                https://www.zbooni.com/payment-policy
                              </Link>
                              . We may, acting in our sole and absolute
                              discretion, change Payment Processors who are
                              processing and settling any of your Transactions
                              from time to time. We reserve the right to take
                              measures in accordance with applicable law in the
                              event a Payment Processor experiences any network
                              interruption or technical glitches. However, you
                              acknowledge and agree that we are not responsible
                              nor liable for any technical malfunctions, network
                              interruptions, network failures, or other issues
                              that Payment Processors may experience which may
                              have an impact on the Service from time to time.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>5.2.3.</span>
                            <span>
                              By installing, accessing, using, or subscribing to
                              our Services, you indicate that you have read,
                              acknowledged, agreed, and accepted the terms of
                              service, privacy policy, and other terms and
                              policies of such Payment Processors (“
                              <span className="font-bold">Processor Terms</span>
                              ”). In the event of any inconsistency between this
                              Agreement and the Processor Terms, this Agreement
                              shall prevail, except in the event of any
                              inconsistency between this Agreement and the
                              specific provisions of Processor Terms relating to
                              payment processing and settling, or the processor
                              account, in which case such specific provision
                              under the Processor Terms shall prevail.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>5.2.4.</span>
                            <span>
                              Zbooni is not responsible or liable for any errors
                              or omissions or Payment Processor related issues.
                              Further, Payment Processors may use, store, and
                              disclose your information solely in accordance
                              with their policies. We assume no responsibility
                              or liability for the privacy practices or any
                              other actions of any Payment Processor. Further,
                              we assume no responsibility or liability for any
                              damage or loss caused or alleged to be caused by
                              or in connection with the use of or reliance on
                              any such Payment Processor.
                            </span>
                          </p>
                        </div>
                      </div>
                      <div className="pl-6 sm:pl-10">
                        <p className="flex gap-x-5">
                          <span>5.3.</span>
                          <span className="underline">
                            Authorization for Handling Fund
                          </span>
                        </p>
                        <div className="flex flex-col gap-y-5 mt-3 pl-8 sm:pl-12">
                          <p className="flex gap-x-5">
                            <span>5.3.1.</span>
                            <span>
                              By installing, accessing, using, or subscribing to
                              our Services, you expressly agree, acknowledge,
                              and authorize Zbooni to hold, receive, and
                              disburse funds on your behalf when such funds from
                              your Transactions settle from the Payment
                              Networks. You further agree, acknowledge, and
                              authorize Zbooni to determine how your Transaction
                              settlement funds should be disbursed to you (such
                              as by bank transfer or by sending you a paper
                              check payable to you) and the timing of such
                              disbursements.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>5.3.2.</span>
                            <span>
                              You also agree, acknowledge and authorize Zbooni
                              to hold settlement funds in a deposit account at a
                              local financial institution (“
                              <span className="font-bold">Deposit Account</span>
                              ”) of our choosing (acting in our sole and
                              absolute discretion) pending disbursement of the
                              funds to you in accordance with the terms of this
                              Agreement. Further, you acknowledge, agree, and
                              authorize Zbooni to change Deposit Accounts for
                              any reason whatsoever.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>5.3.3.</span>
                            <span>
                              All disbursements amounts shall be disbursed to
                              you through bank transfers from the Deposit
                              Account to your bank account or through other
                              legally permissible modes to you, such as a paper
                              check payable to you or peer-to-peer wallet
                              transfers, as may be determined by Zbooni in its
                              sole and absolute discretion and in accordance
                              with applicable law (“
                              <span className="font-bold">
                                Merchant Account
                              </span>
                              ”).
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>5.3.4.</span>
                            <span>
                              You further agree and acknowledge that Zbooni
                              cannot and will not assume any responsibility or
                              liability for any incorrect banking or other
                              account information provided by the Merchant.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>5.3.5.</span>
                            <span>
                              You acknowledge and agree that you are not
                              entitled to any interest or other compensation
                              associated with the settlement funds held in the
                              Deposit Account pending settlement to your
                              Merchant Account, that you have no right to direct
                              that Deposit Account, and that you may not assign
                              any interest or grant any security interest or
                              lien in the settlement funds or the Deposit
                              Account.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>5.3.6.</span>
                            <span>
                              From time to time, we may make information
                              available to you in your Zbooni Account regarding
                              anticipated settlement amounts that we have
                              received on your behalf from the Payment Networks
                              and are being held by us pending settlement. The
                              settlement information reflected in your Zbooni
                              Account is for reporting and informational
                              purposes only and does not create any ownership or
                              other rights in settlement funds, which are
                              provisional credits only until such funds are
                              credited to your Merchant Account. Your
                              authorizations set forth in this Clause 5 shall
                              remain in full force and effect until your Zbooni
                              Account is closed or terminated.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>5.3.7.</span>
                            <span>
                              <span className="underline">
                                Taxes and Reporting
                              </span>
                              . It is your responsibility to determine what, if
                              any, taxes and duties apply to the sale of your
                              goods and services and/or the payments you receive
                              in connection with your use of the Service (“
                              <span className="font-bold">Taxes</span>”). It is
                              solely your responsibility to assess, collect,
                              report, or remit the correct tax to the proper tax
                              authority. We are not obligated to, nor will we
                              determine whether Taxes apply, calculate, collect,
                              report, or remit any Taxes to any tax authority
                              arising from any transaction. You acknowledge that
                              we may make certain reports to tax authorities
                              regarding transactions that we process and
                              merchants to which we provide card payment
                              services. For the avoidance of doubt, each party
                              shall be responsible for the payment of all taxes
                              for which such party is legally responsible as
                              determined by applicable law or any applicable
                              governmental authority.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>5.3.8.</span>
                            <span>
                              For further details regarding handling, settling,
                              and disbursing funds to you, please refer to our
                              Payment Policy located at{" "}
                              <Link
                                to="/payment-policy"
                                className="text-blue underline"
                              >
                                https://www.zbooni.com/payment-policy
                              </Link>
                              .
                            </span>
                          </p>
                        </div>
                      </div>
                      <div className="pl-6 sm:pl-10">
                        <p className="flex gap-x-5">
                          <span>5.4.</span>
                          <span className="underline">Payment Methods</span>
                        </p>
                        <div className="flex flex-col gap-y-5 mt-3 pl-8 sm:pl-12">
                          <p className="flex gap-x-5">
                            <span>5.4.1.</span>
                            <span>
                              The card processing service supports most issued
                              cards with a Payment Network logo, including
                              credit, debit, pre-paid, or gift cards. Zbooni
                              will only process Card Transactions that have been
                              authorized by the applicable Payment Network or
                              Card issuer. You are solely responsible for
                              verifying the identity of users and of the
                              eligibility of a presented payment card used to
                              purchase your products and services, and Zbooni
                              does not guarantee or assume any liability for
                              transactions authorized and completed which may
                              later be reversed or charged back. You are solely
                              responsible for all reversed or charged back
                              transactions, regardless of the reason for, or
                              timing of, the Reversal or Chargeback. Zbooni may
                              add or remove one or more types of supported
                              payment methods at any time without prior notice
                              to you. Please refer to Clause 7.6 in these Terms
                              and Conditions for further details regarding
                              Reversals and Chargebacks.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>5.4.2.</span>
                            <span>
                              The Payment Networks have established guidelines,
                              bylaws, rules, and regulations (“
                              <span className="font-bold">
                                Payment Network Rules
                              </span>
                              ”) which are available at (
                              <a
                                href="https://usa.visa.com/content/dam/VCOM/download/about-visa/visa-rules-public.pdf"
                                rel="noreferrer"
                                target="_blank"
                                className="text-blue underline"
                              >
                                VISA
                              </a>{" "}
                              and{" "}
                              <a
                                href="https://www.mastercard.com/content/dam/mccom/shared/business/support/rules-pdfs/mastercard-rules.pdf"
                                rel="noreferrer"
                                target="_blank"
                                className="text-blue underline"
                              >
                                MasterCard
                              </a>
                              ). By installing, accessing, using, or subscribing
                              to our Services, you indicate that you have read,
                              acknowledged, agreed, and accepted the Payment
                              Network Rules applicable to you. Further, you
                              agree and acknowledge that you shall comply with
                              all applicable Payment Network Rules. Please note
                              that the Payment Networks reserve the right to
                              amend the Payment Network Rules from time to time
                              and it is your responsibility to be updated with
                              such changes. The Payment Processor, acting on
                              behalf of Zbooni, reserves the right to amend the
                              Agreement at any time with notice to you as
                              necessary to comply with Network Rules or
                              otherwise address changes in the Service.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>5.4.3.</span>
                            <span>
                              Zbooni, or its agent, acts as the merchant of
                              record on all Transactions. The name ‘Zbooni’ or
                              that of the agent may appear in Customers&apos;
                              credit or debit card statements. To avoid Customer
                              confusion and Transaction disputes, you must make
                              your Customers aware of this. You agree to
                              indemnify the Zbooni Indemnified Parties from any
                              and all costs arising in any dispute due to your
                              failure to do so.
                            </span>
                          </p>
                        </div>
                      </div>
                      <div className="pl-6 sm:pl-10">
                        <p className="flex gap-x-5">
                          <span>5.5.</span>
                          <span className="underline">
                            Customer Service and the Zbooni Account Manager
                          </span>
                        </p>
                        <div className="flex flex-col gap-y-5 mt-3 pl-8 sm:pl-12">
                          <p className="flex gap-x-5">
                            <span>5.5.1.</span>
                            <span>
                              You will be assigned a Zbooni account manager who
                              shall inter-alia provide you with customer service
                              to resolve any issues relating to your Zbooni
                              Account, your card payment processing, use of our
                              software, and the distribution of funds to your
                              Merchant Account. You and you solely, are
                              responsible for providing service to your
                              Customers for any and all issues related to your
                              products and services, including but not limited
                              to issues arising from the processing of
                              Customers&apos; Cards through the Service. Details
                              of the Zbooni account manager will be provided to
                              you when your Zbooni Account is successfully
                              registered in accordance with the Agreement.
                            </span>
                          </p>
                        </div>
                      </div>
                      <div className="pl-6 sm:pl-10">
                        <p className="flex gap-x-5">
                          <span>5.6.</span>
                          <span className="underline">Insights</span>
                        </p>
                        <div className="flex flex-col gap-y-5 mt-3 pl-8 sm:pl-12">
                          <p className="flex gap-x-5">
                            <span>5.6.1.</span>
                            <span>
                              We may also offer aggregate and anonymous data and
                              other insight features (“
                              <span className="font-bold">Zbooni Insights</span>
                              ”), which are intended to promote transparency,
                              help you to better understand your Transactions,
                              and help you make more informed decisions. Unless
                              indicated otherwise, we provide such Zbooni
                              insights based on information obtained anonymously
                              in accordance with applicable law. However, such
                              Zbooni Insights cannot be guaranteed. Accordingly,
                              such Zbooni Insights may include a certain degree
                              of margin of error. Further, all data collected is
                              encrypted using commercially reasonable standards
                              and is not linked to any Merchant’s or Customer’s
                              personal information.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>5.6.2.</span>
                            <span>
                              In order to obtain the data and other input
                              required to provide Zbooni Insights, we may use
                              certain third-party providers (“
                              <span className="font-bold">
                                Third Party Providers
                              </span>
                              ”). In such event, when you elect to use any of
                              the features provided through the Services, you
                              indicate that you have read, acknowledged, agreed,
                              and accepted the terms of service and privacy
                              policy of such Third Party Providers. Zbooni is
                              not responsible or liable for any errors or
                              omissions or Third Party Provider-related issues
                              with respect to the account or the accuracy of
                              said information retrieved or obtained from these
                              third parties. Further, Third Party Providers use,
                              store, and disclose your information solely in
                              accordance with their policies. We assume no
                              responsibility or liability for the privacy
                              practices or any other actions of any third-party
                              website or service of such Third Party Providers.
                              Further, we assume no responsibility or liability
                              for any damage or loss caused or alleged to be
                              caused by or in connection with the use of or
                              reliance on any such Third Party Providers.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>5.6.3.</span>
                            <span>
                              We do not guarantee the accuracy or completeness
                              of Zbooni Insights, and you are responsible for
                              how you use them, and you should do your
                              independent research regarding any such Zbooni
                              Insights.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>5.6.4.</span>
                            <span>
                              The Service is provided to you on an “as is”
                              basis, with all faults and defects without
                              warranty of any kind. To the maximum extent
                              permitted under applicable law, Zbooni, on its
                              behalf and behalf of its affiliates and their
                              respective licensors and service providers,
                              expressly disclaims all warranties, whether
                              express, implied, statutory, or otherwise, with
                              respect to the Service, including all implied
                              warranties of merchantability, fitness for a
                              particular purpose, title and non-infringement,
                              and warranties that may arise out of the course of
                              dealing, course of performance, usage or trade
                              practice. Without limitation to the generality of
                              the foregoing, Zbooni provides no warranty or
                              undertaking, and makes no representation of any
                              kind that the Service will meet your requirements,
                              achieve any intended results, be compatible or
                              work with any other software, applications,
                              systems, or services, operate without
                              interruption, meet any performance or reliability
                              standards or be error-free or that any errors or
                              defects can or will be corrected.
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </AccordionPanel>
                  <AccordionItem
                    id="privacy"
                    className="flex justify-between h-[124px]"
                  >
                    <div className="flex items-center">
                      <p className="flex gap-x-3 sm:gap-x-6 text-lg font-extrabold sm:text-xl">
                        <span>6.</span>
                        <span>Privacy</span>
                      </p>
                    </div>
                  </AccordionItem>
                  <AccordionPanel id="privacy" className="border-b">
                    <div className="mb-10 flex flex-col gap-y-5">
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>6.1.</span>
                        <span>
                          Zbooni maintains commercially reasonable
                          administrative, technical and physical procedures to
                          protect all the personal information regarding you and
                          your customers. However, we cannot guarantee that
                          unauthorized third parties will never be able to
                          defeat those measures or use such personal information
                          for improper purposes. You acknowledge that you
                          provide this personal information regarding you and
                          your Customers at your own risk. For further details
                          regarding data privacy, please refer to our Data
                          Privacy Policy located at{" "}
                          <Link
                            to="/data-privacy-policy/"
                            className="text-blue underline"
                          >
                            https://www.zbooni.com/data-privacy-policy
                          </Link>
                          .
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>6.2.</span>
                        <span>
                          If we believe that a security breach or compromise of
                          data has occurred, Zbooni may require you to have a
                          third party auditor that is approved by Zbooni conduct
                          a security audit of your systems and facilities and
                          issue a report to be provided to Zbooni, Payment
                          Processors, financial banks, and the Payment Networks.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>6.3.</span>
                        <span>
                          Your privacy and the protection of your data are very
                          important to us. Zbooni works with the Payment
                          Processor to provide the Zbooni service, and both
                          Zbooni and the Payment Processor may collect or
                          receive certain personal data about you and your
                          Customers.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>6.4.</span>
                        <span>
                          You represent to us that you are in compliance with
                          all applicable privacy laws, you have obtained all
                          necessary rights and consents under applicable law to
                          disclose to us, or allow Zbooni or Payment Processor
                          to collect, use, retain and disclose any Customer data
                          that you provide to us or authorize us to collect,
                          including information that we may collect directly
                          from your end-users via cookies or other means, and
                          that we will not be in breach of any such laws by
                          collecting, receiving, using and disclosing such
                          information in connection with the Service. As between
                          the parties to this Agreement, you are solely
                          responsible for disclosing to your Customers that we
                          are processing credit card transactions for you and
                          obtaining data from such Customers. If you receive
                          information about others, including Customers, through
                          the use of the Service, you must keep such information
                          confidential and only use it in connection with the
                          Service. You may not disclose or distribute any such
                          information to a third party or use any such
                          information for marketing purposes unless you receive
                          the express consent of the user to do so. You may not
                          disclose card numbers to any third party, other than
                          in connection with processing a card transaction
                          requested by the Customer.
                        </span>
                      </p>
                    </div>
                  </AccordionPanel>
                  <AccordionItem
                    id="processing-card-transactions-and-receiving-your-funds"
                    className="flex justify-between h-[124px]"
                  >
                    <div className="flex items-center">
                      <p className="flex gap-x-3 sm:gap-x-6 text-lg font-extrabold sm:text-xl">
                        <span>7.</span>
                        <span>
                          Processing Card Transactions and Receiving Your Funds
                        </span>
                      </p>
                    </div>
                  </AccordionItem>
                  <AccordionPanel
                    id="processing-card-transactions-and-receiving-your-funds"
                    className="border-b"
                  >
                    <div className="mb-10 flex flex-col gap-y-5">
                      <div className="pl-6 sm:pl-10">
                        <p className="flex gap-x-5">
                          <span>7.1.</span>
                          <span className="underline">
                            Processing Card Transactions
                          </span>
                        </p>
                        <div className="flex flex-col gap-y-5 mt-3 pl-8 sm:pl-12">
                          <p className="flex gap-x-5">
                            <span>7.1.1.</span>
                            <span>
                              You acknowledge and agree that you will honor all
                              eligible Cards presented for payment by your
                              Customers for your goods and services in
                              accordance with the Payment Network Rules, this
                              Agreement, Payment Processor Terms, and any
                              operating guides that we may provide you from time
                              to time.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>7.1.2.</span>
                            <span>
                              You agree that you will obtain an authorization
                              from the Payment Network(s) for each Card
                              Transaction, as required under the Payment Network
                              Rules, and will not submit a Card Transaction for
                              settlement where there is a negative authorization
                              or the Card is otherwise expired. You acknowledge
                              that the existence of an affirmative authorization
                              from us or the Payment Networks does not mean that
                              a particular Card Transaction will not be subject
                              to Chargeback, Reversal, or Claim at a later date.
                              You will not impose any fee or surcharge on a
                              Customer that seeks to use an eligible payment
                              Card.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>7.1.3.</span>
                            <span>
                              You will provide a receipt to the Customer at the
                              conclusion of the Transaction that includes all
                              information required under Payment Network Rules
                              and applicable law. You will display all Payment
                              Network marks in accordance with the Payment
                              Network Rules and will use such marks only to
                              indicate that you accept their Cards for payment.
                            </span>
                          </p>
                        </div>
                      </div>
                      <div className="pl-6 sm:pl-10">
                        <p className="flex gap-x-5">
                          <span>7.2.</span>
                          <span className="underline">
                            Payouts and Transaction History
                          </span>
                        </p>
                        <div className="flex flex-col gap-y-5 mt-3 pl-8 sm:pl-12">
                          <p className="flex gap-x-5">
                            <span>7.2.1.</span>
                            <span>
                              We will disburse the funds settling from the
                              Payment Networks to your Merchant Account, in
                              accordance with our Commercial Policy (located at{" "}
                              <Link
                                to="/payment-policy"
                                className="text-blue underline"
                              >
                                https://www.zbooni.com/payment-policy
                              </Link>
                              ) in the amounts actually received (less Zbooni
                              Fees as defined below) for Card Transactions
                              submitted to our Service.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>5.2.2.</span>
                            <span>
                              The payouts will be made to the Merchant Account
                              you provide for your Zbooni Account. The Merchant
                              Account must be an account located at a bank in
                              the Territory and held in the name of the
                              Merchant. You are responsible for the accuracy and
                              correctness of the information regarding your
                              Merchant Account. Funds for any given transaction
                              will not be transferred to your Merchant Account
                              until the Transaction is deemed complete.
                              Transactions will be deemed complete when we have
                              received funds settling from the Payment Networks
                              and when we or our processing financial
                              institutions have accepted such funds. The actual
                              timing of the transfers to your Merchant Account
                              of the settling funds will be subject to the
                              Payment Policy located at{" "}
                              <Link
                                to="/payment-policy"
                                className="text-blue underline"
                              >
                                https://www.zbooni.com/payment-policy
                              </Link>
                              .
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>7.2.3.</span>
                            <span>
                              Notwithstanding the foregoing, you acknowledge
                              that all credits for funds provided to you are
                              provisional and subject to reversal including
                              without limitation if there are adjustments for
                              inaccuracies and errors (including rejects) and
                              Chargebacks, Reversals, or Claims in accordance
                              with this Agreement and the Payment Network Rules,
                              whether or not a Transaction is charged back by
                              the issuer of the Card or the Cardholder.
                              Accordingly, you authorize us to initiate reversal
                              or adjustment (debit or credit) entries to the
                              Reserve Account and to initiate or suspend such
                              entries in accordance with this Agreement as may
                              be necessary to grant or reverse provisional
                              credit for any Transaction.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>7.2.4.</span>
                            <span>
                              After each payout of card settlement funds to your
                              Merchant Account, we will update information in
                              your Zbooni Account to reflect settlement.
                              Information regarding your Card Transactions
                              processed and settled with the Services (“
                              <span className="font-bold">
                                Transaction History
                              </span>
                              ”) will be available to you upon request.
                            </span>
                          </p>
                        </div>
                      </div>
                      <div className="pl-6 sm:pl-10">
                        <p className="flex gap-x-5">
                          <span>7.3.</span>
                          <span className="underline">Payout Schedule</span>
                        </p>
                        <div className="flex flex-col gap-y-5 mt-3 pl-8 sm:pl-12">
                          <p className="flex gap-x-5">
                            <span>7.3.1.</span>
                            <span>
                              The payout schedule refers to the time it takes
                              for us to initiate a transfer to your Merchant
                              Account of settlement funds arising from Card
                              Transactions processed through the Service
                              (“Payout Schedule”). Once your Merchant Account
                              information has been reviewed, Zbooni will
                              initiate the transfer of settlement funds (net of
                              the Zbooni Fees, Chargebacks, and other funds owed
                              to us for any reason) in accordance with the
                              Payout Schedule, the terms of which are set out in
                              the Payment Policy located at{" "}
                              <Link
                                to="/payment-policy"
                                className="text-blue underline"
                              >
                                https://www.zbooni.com/payment-policy
                              </Link>
                              .
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>7.3.2.</span>
                            <span>
                              Zbooni shall bear the initial transfer cost
                              arising from initiating the transfer of settlement
                              funds to your Merchant Account. However, we shall
                              not bear any other costs associated with the
                              receipt of payment by Merchant. These additional
                              charges may include local bank costs, charges and
                              fees, intermediary bank costs, charges and fees,
                              currency exchange/forex costs, charges and fees,
                              fees and costs associated with applicable laws,
                              compliance and KYC costs, charges and fees, and
                              other administrative costs, charges and fees which
                              may be issued by financial institutions and/or
                              governmental authorities. Accordingly, the total
                              amount received by the Merchant will depend on any
                              such charges, costs and fees, and the fees set out
                              in the Payment Policy including but not limited to
                              the Zbooni Fees.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>7.3.3.</span>
                            <span>
                              The transfer of settlement funds to the Merchant
                              Account is dependent on the bank timescales. While
                              the settlement funds should normally be credited
                              to your Merchant Account within 1-2 business days
                              of us initiating the payout, we cannot provide a
                              firm date and you should refer to your bank for
                              guidance. Payments initiated to the Merchant
                              Account, as evidenced by confirmation from Zbooni,
                              shall be deemed full and final settlement of the
                              amounts owed to the Merchant. Further, we are not
                              responsible for any action taken by the
                              institution holding your Merchant Account that may
                              result in some or all of the funds not being
                              credited to your Merchant Account or not being
                              made available to you in your Merchant Account.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>7.3.4.</span>
                            <span>
                              The Payment Processor, on behalf of Zbooni,
                              reserves the right to change the Payout Schedule
                              or suspend payouts to your Merchant Account should
                              we determine it is necessary due to pending
                              disputes, excessive or anticipated excessive
                              Chargebacks or refunds, or other suspicious
                              activity associated with your use of the Service
                              including but not limited to failure to meet any
                              verification standards set out by Zbooni in this
                              Agreement or if required by law or court order.
                            </span>
                          </p>
                        </div>
                      </div>
                      <div className="pl-6 sm:pl-10">
                        <p className="flex gap-x-5">
                          <span>7.4.</span>
                          <span className="underline">
                            Reconciliations and Errors
                          </span>
                        </p>
                        <div className="flex flex-col gap-y-5 mt-3 pl-8 sm:pl-12">
                          <p className="flex gap-x-5">
                            <span>7.4.1.</span>
                            <span>
                              Your Transaction History will be available to you
                              in the Zbooni App, the business dashboard set out
                              in your Zbooni Account, and upon request by
                              emailing us at{" "}
                              <a
                                className="text-blue underline"
                                href="mailto:hello@zbooni.com"
                                lang="en"
                              >
                                hello@zbooni.com
                              </a>
                              . Except as required by applicable law, you are
                              solely responsible for reconciling your
                              Transaction History with your actual Transactions.
                              You agree to notify us of any discrepancies
                              arising from such reconciliation and verification.
                              We will investigate any reported discrepancies and
                              attempt to rectify any errors that you or we
                              discover. In the event you are owed money as a
                              result of the discrepancy, as may be determined by
                              Zbooni in its sole and absolute discretion, acting
                              reasonably, we will transfer funds to your
                              Merchant Account in the next scheduled payout.
                              Your failure to notify us of an error or
                              discrepancy in your Transaction History within
                              sixty (60) days of when it first appears on your
                              Transaction History will be deemed a waiver of any
                              right to amounts owed to you in connection with
                              any such error or discrepancy in processing your
                              payments. If you submit or cause us to process
                              transactions erroneously, you agree to contact us
                              immediately. We will investigate any reported
                              errors and attempt to rectify any errors that you
                              or we discover by crediting or debiting your
                              Zbooni Account as appropriate. Zbooni will only
                              correct transactions that you process incorrectly
                              if and when you notify us of such an error. Your
                              failure to notify us of a processing error within
                              thirty (30) days of when it first appears on your
                              electronic Transaction History will be deemed a
                              waiver of any right to amounts owed to you.
                            </span>
                          </p>
                        </div>
                      </div>
                      <div className="pl-6 sm:pl-10">
                        <p className="flex gap-x-5">
                          <span>7.5.</span>
                          <span className="underline">Refunds and Returns</span>
                        </p>
                        <div className="flex flex-col gap-y-5 mt-3 pl-8 sm:pl-12">
                          <p className="flex gap-x-5">
                            <span>7.5.1.</span>
                            <span>
                              By installing, accessing, using, or subscribing to
                              our Services, you agree and acknowledge to submit
                              any and all refunds and adjustments for returns of
                              your products and services through the Service to
                              the Customer’s card in accordance with the terms
                              of this Agreement, Payment Network Rules, and
                              applicable law. Payment Network Rules require that
                              you will (i) maintain a fair return, cancellation,
                              or adjustment policy; (ii) disclose your return or
                              cancellation policy to customers at the time of
                              purchase, (iii) not give cash refunds to a
                              customer in connection with a Card sale, unless
                              required by law; and (iv) not accept cash or any
                              other item of value for preparing a Card sale
                              refund.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>7.5.2.</span>
                            <span>
                              Full refunds must be for the exact amount of the
                              original transaction including tax, handling
                              charges, and other charges. The refund amount may
                              not exceed the original sale amount except by an
                              amount equal to any reimbursements to the customer
                              for postage costs incurred for product returns.
                              Refunds processed through the Service must be
                              submitted within sixty (60) days of the original
                              transaction but in all cases, within three (3)
                              days of approving the Cardholder refund.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>7.5.3.</span>
                            <span>
                              For processed refunds, we will deduct the refund
                              amount (including any applicable Fees) from (i)
                              settlement funds owed to you from the processing
                              of other card transactions, or (ii) funds in any
                              Reserve Account (as defined below). If these funds
                              are not sufficient, you agree to pay all funds
                              owed to us upon demand. You are solely responsible
                              for accepting and processing returns of your
                              products and services; we have no responsibility
                              or obligation for processing such returns.
                            </span>
                          </p>
                        </div>
                      </div>
                      <div className="pl-6 sm:pl-10">
                        <p className="flex gap-x-5">
                          <span>7.6.</span>
                          <span className="underline">Chargebacks</span>
                        </p>
                        <div className="flex flex-col gap-y-5 mt-3 pl-8 sm:pl-12">
                          <p className="flex gap-x-5">
                            <span>7.6.1.</span>
                            <span>
                              A Chargeback is typically caused when a Customer
                              disputes a charge that appears on their bill. A
                              Chargeback may result in the reversal of a
                              transaction, with the amount charged back to you.
                              You can be assessed Chargebacks for (i) Customer
                              disputes, (ii) unauthorized or improperly
                              authorized Transactions, or (iii) Transactions
                              that do not comply with applicable law, Payment
                              Network Rules, Payment Processor Terms, the terms
                              of this Agreement, or are allegedly unlawful or
                              suspicious, or (iv) any reversals for any reason
                              by the Payment Network, the acquiring bank (in
                              terms of the Payment Network Rules), Payment
                              Processor, or the Customer’s card issuing
                              financial institution.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>7.6.2.</span>
                            <span>
                              When a Chargeback is issued, you are immediately
                              liable to Zbooni for the full amount of payment of
                              the Chargeback plus any associated fees, fines,
                              expenses, or penalties (including those assessed
                              by the Payment Networks or our Payment
                              Processors). You agree that we may recover these
                              amounts by debiting your Reserve Account or
                              setting off any amounts owed to you by us from
                              time to time. If we are unable to recover funds
                              related to a Chargeback for which you are liable,
                              you will pay us the full amount of the Chargeback
                              immediately upon demand. You agree to pay all
                              costs and expenses, including without limitation
                              attorneys&apos; fees and other legal expenses,
                              incurred by or on behalf of us in connection with
                              the collection of any unpaid Chargebacks unpaid by
                              you.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>7.6.3.</span>
                            <span>
                              Further, if we reasonably believe that a
                              Chargeback is likely with respect to any
                              Transaction, we may withhold the amount of the
                              potential Chargeback from payments otherwise due
                              to you under this Agreement until such time that:
                              (a) a Chargeback is assessed due to a
                              customer&apos;s complaint, in which case we will
                              retain the funds; (b) the period of time under
                              applicable law or regulation by which the customer
                              may dispute that the transaction has expired, or
                              (c) we determine that a Chargeback on the
                              transaction will not occur.
                            </span>
                          </p>
                        </div>
                      </div>
                      <div className="pl-6 sm:pl-10">
                        <p className="flex gap-x-5">
                          <span>7.7.</span>
                          <span className="underline">
                            Excessive Chargebacks
                          </span>
                        </p>
                        <div className="flex flex-col gap-y-5 mt-3 pl-8 sm:pl-12">
                          <p className="flex gap-x-5">
                            <span>7.7.1.</span>
                            <span>
                              At any point, Zbooni, the Payment Processor,
                              relevant local financial institutions, and the
                              Payment Networks, may determine that you are
                              incurring excessive Chargebacks. Excessive
                              Chargebacks may result in additional fees,
                              penalties, or fines. Excessive Chargebacks may
                              also result in additional controls and
                              restrictions to your use of the Service, including
                              without limitation, (i) changes to the terms of
                              your Reserve Account, (ii) increases to your
                              applicable fees, (iii) delays in your Payout
                              Schedule, or (iv) possible suspension or
                              termination of your Zbooni Account and the
                              Service. The Payment Networks may also place
                              additional controls or restrictions as part of
                              their monitoring programs for merchants with
                              excessive Chargebacks.
                            </span>
                          </p>
                        </div>
                      </div>
                      <div className="pl-6 sm:pl-10">
                        <p className="flex gap-x-5">
                          <span>7.8.</span>
                          <span className="underline">Zbooni Fees</span>
                        </p>
                        <div className="flex flex-col gap-y-5 mt-3 pl-8 sm:pl-12">
                          <p className="flex gap-x-5">
                            <span>7.8.1.</span>
                            <span>
                              You agree to pay the Zbooni Fees (“
                              <span className="font-bold<">Zbooni Fees</span>”)
                              assessed by us to you for providing the Services.
                              These fees will be calculated pursuant to the Fee
                              Schedule incorporated in the Payment Policy
                              located at{" "}
                              <Link
                                to="/payment-policy"
                                className="text-blue underline"
                              >
                                https://www.zbooni.com/payment-policy
                              </Link>
                              . We reserve the right to revise our Zbooni Fees
                              at any time, subject to a thirty (30) day notice
                              period to you.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>7.8.2.</span>
                            <span>
                              You acknowledge that you are also responsible for
                              any penalties or fines imposed on us or directly
                              on you by any Payment Network or financial
                              institution as a result of your activities.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>7.8.3.</span>
                            <span>
                              For further details regarding fees, please refer
                              to the Payment Policy located at{" "}
                              <Link
                                to="/payment-policy"
                                className="text-blue underline"
                              >
                                https://www.zbooni.com/payment-policy
                              </Link>
                              .
                            </span>
                          </p>
                        </div>
                      </div>
                      <div className="pl-6 sm:pl-10">
                        <p className="flex gap-x-5">
                          <span>7.9.</span>
                          <span className="underline">
                            Our Collection Rights
                          </span>
                        </p>
                        <div className="flex flex-col gap-y-5 mt-3 pl-8 sm:pl-12">
                          <p className="flex gap-x-5">
                            <span>7.9.1.</span>
                            <span>
                              To the extent permitted by law, we may collect any
                              obligations you owe us under this Agreement by
                              deducting the corresponding amounts from the
                              Reserve Account or from funds payable to you
                              arising from the settlement of Transactions. Fees
                              will be assessed at the time a Transaction is
                              processed and will be first deducted from the
                              funds received for such Transactions. If the
                              settlement amounts or Reserve Account are not
                              sufficient to meet your obligations to us, you
                              will pay us the full amount immediately upon
                              demand. Your failure to fully pay the amounts that
                              you owe us on demand will be a breach of this
                              Agreement. You will be liable for our costs
                              associated with collection in addition to the
                              amount owed, including without limitation
                              attorneys&apos; fees and expenses, costs of any
                              arbitration or court proceeding, collection agency
                              fees, and any applicable interest.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>7.9.2.</span>
                            <span>
                              Additionally, we may require a personal guaranty
                              from a principal of a business for funds owed
                              under this Agreement. If we require a personal
                              guarantee we will specifically inform you in
                              advance.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>7.9.3.</span>
                            <span>
                              In addition to the amount due, delinquent accounts
                              may be charged with fees that are incidental to
                              the collection of delinquent accounts and
                              Chargebacks including, but not limited to,
                              collection fees and convenience fees, and other
                              third parties charges.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>7.9.4.</span>
                            <span>
                              You hereby explicitly agree that all communication
                              in relation to delinquent accounts will be made by
                              electronic mail or by phone, as provided to Zbooni
                              by you. Such communication may be made by Zbooni
                              or by anyone on its behalf, including but not
                              limited to a third party collection agent.
                            </span>
                          </p>
                        </div>
                      </div>
                      <div className="pl-6 sm:pl-10">
                        <p className="flex gap-x-5">
                          <span>7.10.</span>
                          <span className="underline">Reserves</span>
                        </p>
                        <div className="flex flex-col gap-y-5 mt-3 pl-8 sm:pl-12">
                          <p id="7-10-1" className="flex gap-x-5 scroll-mt-20">
                            <span>7.10.1.</span>
                            <span>
                              Funds held in reserves are amounts of money set
                              aside to cover Chargebacks, refunds, or other
                              payment obligations under this Agreement (“Reserve
                              Account”). We, in our discretion, will set the
                              terms of your Reserve Account and notify you of
                              such terms, which may require that a certain
                              amount (including the full amount) of the funds
                              received for your Transaction is held for a period
                              of time or that additional amounts are held in the
                              Reserve Account for reasons we determine in our
                              sole and absolute discretion, acting reasonably,
                              such as reserving up to 15% of a Transaction
                              pending confirmation regarding the tax status of
                              cross-border Transactions. We, in our discretion,
                              may elect to change the terms of the Reserve
                              Account at any time for any reason based on your
                              payment processing history or as requested by our
                              payment processors.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>7.10.2.</span>
                            <span>
                              We may require you to fund the Reserve Account by
                              means of (i) any funds payouts made or due to you
                              for card transactions submitted to the Service,
                              (ii) other sources of funds associated with your
                              Zbooni account, or(iii) requesting that you
                              provide funds to us for deposit to the Reserve
                              Account. You agree that you are not entitled to
                              any interest or other compensation associated with
                              the funds held in the Reserve Account, that you
                              have no right to direct the Reserve Account, that
                              you have no legal interest in those funds or the
                              Reserve Account and that you may not assign any
                              interest in those funds or Reserve Account.
                            </span>
                          </p>
                        </div>
                      </div>
                      <div className="pl-6 sm:pl-10">
                        <p className="flex gap-x-5">
                          <span>7.11.</span>
                          <span className="underline">Security Interest</span>
                        </p>
                        <div className="flex flex-col gap-y-5 mt-3 pl-8 sm:pl-12">
                          <p className="flex gap-x-5">
                            <span>7.11.1.</span>
                            <span>
                              You agree and acknowledge that you expressly grant
                              us a lien and security interest in the Reserve
                              Account, all Card Transactions (including future
                              Card Transactions), any rights to receive credits
                              or payments under this Agreement, and all deposits
                              and other property of yours possessed or
                              maintained by us on your behalf. You will execute,
                              deliver, and pay the fees for any documents we
                              request to create, perfect, maintain and enforce
                              this security interest.
                            </span>
                          </p>
                        </div>
                      </div>
                      <div className="pl-6 sm:pl-10">
                        <p className="flex gap-x-5">
                          <span>7.12.</span>
                          <span className="underline">Payment Policy</span>
                        </p>
                        <div className="flex flex-col gap-y-5 mt-3 pl-8 sm:pl-12">
                          <p className="flex gap-x-5">
                            <span>7.12.1.</span>
                            <span>
                              For further details regarding processing
                              Transactions and receiving your funds, please
                              refer to the Payment Policy located at{" "}
                              <Link
                                to="/payment-policy"
                                className="text-blue underline"
                              >
                                https://www.zbooni.com/payment-policy
                              </Link>
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </AccordionPanel>
                  <AccordionItem
                    id="restricted-use-and-lawful-purpose"
                    className="flex justify-between h-[124px]"
                  >
                    <div className="flex items-center">
                      <p className="flex gap-x-3 sm:gap-x-6 text-lg font-extrabold sm:text-xl">
                        <span>8.</span>
                        <span>Restricted Use and Lawful Purpose</span>
                      </p>
                    </div>
                  </AccordionItem>
                  <AccordionPanel
                    id="restricted-use-and-lawful-purpose"
                    className="border-b"
                  >
                    <div className="mb-10 flex flex-col gap-y-5">
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>8.1.</span>
                        <span>
                          You acknowledge and agree to use the Services only for
                          lawful purposes, and in accordance with this
                          Agreement, applicable Payment Processor Terms,
                          applicable Payment Network Rules, and all applicable
                          law.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>8.2.</span>
                        <span>
                          You represent, warrant and covenant that you have and
                          shall continue to have all necessary licenses,
                          registrations, consents and other authorizations
                          required under applicable law to use the Services and
                          undertake Transactions.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>8.3.</span>
                        <span>
                          You are required to comply with all laws, rules, and
                          regulations applicable to your use of the Service (for
                          example, those governing financial services, consumer
                          protections, unfair competition, anti-discrimination,
                          or false advertising), including those of all
                          applicable central banks such (for example, you shall
                          obtain all necessary true, accurate and correct
                          information of the Customers and not create or use any
                          ‘spoof’ customer details).
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>8.4.</span>
                        <span>
                          In addition to any other requirements or restrictions
                          set forth in this Agreement, you shall not: (i)
                          utilize the credit available on any Card to provide
                          cash advances to Customers, (ii) submit any card
                          transaction for processing that does not arise from
                          your sale of goods or service to a Customer, (iii) act
                          as a payment intermediary or aggregator or otherwise
                          resell our Services on behalf of any third party, (iv)
                          send what you reasonably believe to be potentially
                          fraudulent authorizations or fraudulent card
                          transaction, or (v) use your Zbooni account or the
                          Service in a manner that Visa, MasterCard, or any
                          other Payment Network reasonably believes to be an
                          abuse of the Payment Network or a violation of Payment
                          Network Rules.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>8.5.</span>
                        <span>
                          You acknowledge and agree that you shall (i) ensure
                          compliance with cardholder data security and storage
                          requirements, (ii) maintain fraud and Chargebacks
                          below Payment Network thresholds, (iii) review and
                          understand the terms of this Agreement, (iv) comply
                          with all this Agreement, Payment Network Rules, and
                          Payment Processor Terms, and (v) retain a copy of this
                          Agreement.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>8.6.</span>
                        <span>
                          You further agree not to, nor to permit any third
                          party to, do any of the following: (i) access or
                          attempt to access our systems, programs or data that
                          are not made available for public use: (ii) copy,
                          reproduce, republish, upload, post, transmit, resell
                          or distribute in any way material from us; (iii)
                          permit any third party to use and benefit from the
                          Service via a rental, lease, timesharing, service
                          bureau or other arrangement; (iv) transfer any rights
                          granted to you under this Agreement; (v) work around
                          any of the technical limitations of the Service, use
                          any tool to enable features or functionalities that
                          are otherwise disabled in the Service, or decompile,
                          disassemble or otherwise reverse engineer the Service,
                          except to the extent that such restriction is
                          expressly prohibited by law; (vi) perform or attempt
                          to perform any actions that would interfere with the
                          proper working of the Service, prevent access to or
                          use of the Service by our other users, or impose an
                          unreasonable or disproportionately large load on our
                          infrastructure; or (vii) otherwise use the Service
                          except as expressly allowed under this Agreement.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>8.7.</span>
                        <span>
                          We reserve the right to not authorize or settle any
                          transaction you submit that we believe violates this
                          Agreement, Payment Processor Terms, Payment Network
                          Rules, or exposes you, other Zbooni users, Payment
                          Processors, or Zbooni to harm, including but not
                          limited to fraud and other criminal acts. You are
                          hereby granting us authorization to share information
                          with law enforcement about you, your Transactions, or
                          your Zbooni Account if we reasonably suspect that your
                          Zbooni Account has been used for an unauthorized,
                          illegal, or criminal purpose.
                        </span>
                      </p>
                    </div>
                  </AccordionPanel>
                  <AccordionItem
                    id="term-and-termination"
                    className="flex justify-between h-[124px]"
                  >
                    <div className="flex items-center">
                      <p className="flex gap-x-3 sm:gap-x-6 text-lg font-extrabold sm:text-xl">
                        <span>9.</span>
                        <span>Term and Termination</span>
                      </p>
                    </div>
                  </AccordionItem>
                  <AccordionPanel
                    id="term-and-termination"
                    className="border-b"
                  >
                    <div className="mb-10 flex flex-col gap-y-5">
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>9.1.</span>
                        <span>
                          <span className="underline">Term</span>. The Agreement
                          is effective upon the date you agree to it (by
                          electronically indicating acceptance) and continues so
                          long as you use the Service or until terminated by
                          Zbooni, Payment Processor, or the relevant local
                          financial institution.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>9.2.</span>
                        <span>
                          <span className="underline">Termination</span>. You
                          may terminate this Agreement at any time. If you
                          deactivate your Zbooni Account, you may re-activate
                          your Zbooni Account at any time by agreeing to the
                          Agreement, Payment Processor Terms, and Payment
                          Network Rules. We may suspend your Zbooni Account and
                          your access to the Service and any funds in your
                          Zbooni Account, or terminate this Agreement, if (i) we
                          determine, in our sole and absolute discretion, at any
                          time, that you are ineligible or no longer eligible
                          for the Service because of the risk associated with
                          your Zbooni Account, including without limitation
                          significant credit or fraud risk, or for any other
                          reason whatsoever, or (ii) you do not comply with any
                          of the provisions of this Agreement, (iii) upon
                          request of a Payment Processor, Payment Network, or
                          pursuant to any applicable law.
                        </span>
                      </p>
                      <div className="pl-6 sm:pl-10">
                        <p className="flex gap-x-5">
                          <span>9.3.</span>
                          <span className="underline">
                            Effects of Termination
                          </span>
                        </p>
                        <div className="flex flex-col gap-y-5 mt-3 pl-8 sm:pl-12">
                          <p className="flex gap-x-5">
                            <span>9.3.1.</span>
                            <span>
                              Upon termination and closing of your Zbooni
                              Account, we will immediately discontinue your
                              access to the Services. You agree to complete all
                              pending Transactions, immediately remove all logos
                              for Cards, and stop accepting new Transactions
                              through the Service. You will not be refunded the
                              remainder of any fees that you have paid for the
                              Service if your access to or use of the Service is
                              terminated or suspended by Zbooni pursuant to
                              Clause 9.2 above. Any outstanding funds as on the
                              date of termination of this Agreement will be paid
                              out to you subject to the terms of the Payout
                              Schedule set out under the Payment Policy located
                              at{" "}
                              <Link
                                to="/payment-policy"
                                className="text-blue underline"
                              >
                                https://www.zbooni.com/payment-policy
                              </Link>
                              . Termination does not relieve you of your
                              obligations as defined in this Agreement and we
                              may elect to continue to hold any funds deemed
                              necessary pending resolution of any other terms or
                              obligations defined in this Agreement, including
                              but not limited to Chargebacks, Zbooni Fees,
                              Refunds, other fees, and costs, or other
                              investigations or proceedings.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>9.3.2.</span>
                            <span>
                              Upon termination you agree: (i) to immediately
                              cease your use of the Service, (ii) to discontinue
                              use of any Zbooni or Payment Processor
                              intellectual property and to immediately remove
                              any Zbooni or Payment Processor references and
                              logos from your website, (iii) that the license
                              granted under this Agreement shall be terminated
                              without any further act of the parties, (iv) that
                              we reserve the right (but have no obligation) to
                              delete all of your information and account data
                              stored on our servers, and (v) we will not be
                              liable to you for compensation, reimbursement, or
                              damages in connection with your use of the
                              Service, or any termination or suspension of the
                              Service or deletion of your information or account
                              data.
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </AccordionPanel>
                  <AccordionItem
                    id="miscellaneous"
                    className="flex justify-between h-[124px]"
                  >
                    <div className="flex items-center">
                      <p className="flex gap-x-3 sm:gap-x-6 text-lg font-extrabold sm:text-xl">
                        <span>10.</span>
                        <span>Miscellaneous</span>
                      </p>
                    </div>
                  </AccordionItem>
                  <AccordionPanel id="miscellaneous" className="border-b">
                    <div className="mb-10 flex flex-col gap-y-5">
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>10.1.</span>
                        <span>
                          <span className="underline">Your License</span>. We
                          grant you a personal, limited, non-exclusive,
                          revocable, non-transferable license, without the right
                          to sublicense, to electronically access and use the
                          Service. The Service includes but is not limited to
                          our Website, Zbooni App, any software, programs,
                          documentation, tools, internet-based services,
                          components, and any updates (including software
                          maintenance, service information, help content, bug
                          fixes, or maintenance releases) thereto provided to
                          you by us. You will be entitled to download updates to
                          the Service, subject to any additional terms made
                          known to you at that time when we make these updates
                          available.
                        </span>
                      </p>
                      <div className="pl-6 sm:pl-10">
                        <p className="flex gap-x-5">
                          <span>10.2.</span>
                          <span className="underline">Ownership</span>
                        </p>
                        <div className="flex flex-col gap-y-5 mt-3 pl-8 sm:pl-12">
                          <p className="flex gap-x-5">
                            <span>10.2.1.</span>
                            <span>
                              The Service is licensed and not sold. We reserve
                              all rights not expressly granted to you in this
                              Agreement. The Service is protected by copyright,
                              trade secret, and other intellectual property
                              laws. We own the title, copyright, and other
                              worldwide Intellectual Property Rights (as defined
                              below) in the Service and all copies of the
                              Service.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>10.2.2.</span>
                            <span>
                              This Agreement does not grant you any rights to
                              our trademarks or service marks. For the purposes
                              of this Agreement, “
                              <span className="font-bold">
                                Intellectual Property Rights
                              </span>
                              ” means all patent rights, copyright rights, mask
                              work rights, moral rights, rights of publicity,
                              trademark, trade dress and service mark rights,
                              goodwill, trade secret rights, and other
                              intellectual property rights as may now exist or
                              hereinafter come into existence, and all
                              applications therefore and registrations,
                              renewals, and extensions thereof, under all
                              applicable law.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>10.2.3.</span>
                            <span>
                              You may choose to or we may invite you to submit
                              comments or ideas about the Service, including
                              without limitation about how to improve the
                              Service or our products (“
                              <span className="font-bold">Ideas</span>”). By
                              submitting any Idea, you agree that your
                              disclosure is gratuitous, unsolicited, and without
                              restriction and will not place us under any
                              fiduciary or other obligation, and that we are
                              free to use the Idea without any additional
                              compensation to you, and/or to disclose the Idea
                              on a non-confidential basis or otherwise to
                              anyone. You further acknowledge that, by
                              acceptance of your submission, we do not waive any
                              rights to use similar or related ideas previously
                              known to us, developed by our employees, or
                              obtained from sources other than you.
                            </span>
                          </p>
                        </div>
                      </div>
                      <div className="pl-6 sm:pl-10">
                        <p className="flex gap-x-5">
                          <span>10.3.</span>
                          <span className="underline">Your Liability</span>
                        </p>
                        <div className="flex flex-col gap-y-5 mt-3 pl-8 sm:pl-12">
                          <p className="flex gap-x-5">
                            <span>10.3.1.</span>
                            <span>
                              You are responsible for all Reversals,
                              Chargebacks, Claims, fines, fees, penalties, and
                              other liability arising out of or relating to your
                              breach of this Agreement, and/or your use of the
                              Service. You agree to reimburse your customer,
                              Zbooni, Processor, relevant local financial
                              institution, any third party designated by Zbooni,
                              Processor, or relevant local financial institution
                              for any and all such liability.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>10.3.2.</span>
                            <span>
                              We will have the final decision-making authority
                              with respect to Claims, including without
                              limitation claims for refunds for purchased items
                              that are filed with us by you or your customers.
                              You will be required to reimburse us for your
                              liability. Your liability will include the full
                              purchase price of the item plus the original
                              shipping cost (and in some cases, you may not
                              receive the item back). You will not receive a
                              refund of any fees paid to us.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>10.3.3.</span>
                            <span>
                              Without limiting the foregoing, you agree to
                              defend, indemnify, and hold harmless Zbooni,
                              Processor, Local financial institution, and their
                              respective employees and agents (collectively
                              &quot;Disclaiming Entities&quot;) from and against
                              any claim, suit, demand, loss, liability, damage,
                              action or proceeding arising out of or relating to
                              (i) your breach of any provision of this
                              Agreement, and/or(ii) your use of the Service,
                              including without limitation any Reversals,
                              Chargebacks, Claims, fines, fees, penalties, and
                              attorneys&apos; fees; (iii) your, or your
                              employee&apos;s or agent&apos;s, negligence or
                              willful misconduct; or (iv) third party indemnity
                              obligations we incur as a direct or indirect
                              result of your acts or omissions (including
                              indemnification of any Payment Network or Issuer).
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>10.3.4.</span>
                            <span>
                              If you are liable for any amounts owed to us, we
                              may immediately remove such amounts from your
                              Reserve Account and deduct the amounts owed to us
                              from such Reserve Account funds. If you do not
                              have sufficient funds in the Reserve Account to
                              cover your liability, you will be required to
                              immediately add additional funds to your Reserve
                              Account to cover funds owed to us. If you do not
                              do so, we may engage in collections efforts to
                              recover such amounts from you at your cost and
                              expense.
                            </span>
                          </p>
                        </div>
                      </div>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>10.4.</span>
                        <span>
                          <span className="underline">
                            Representation and Warranties
                          </span>
                          . You represent and warrant to us that (i) you are at
                          least the age of majority in the jurisdiction where
                          you reside or where you carry out business activities,
                          whichever is higher; (ii) you are eligible to register
                          and use the Service and have the right, power, and
                          ability to enter into and perform under this
                          Agreement; (iii) the name identified by you when you
                          registered is your name or business name under which
                          you sell goods and services; (iv) any sales
                          transaction submitted by you will represent a bona
                          fide sale by you; (v) any sales Transactions submitted
                          by you will accurately describe the goods and/or
                          services sold and delivered to a Customer; (vi) you
                          will fulfill all of your obligations to each Customer
                          for which you submit a Transaction and will resolve
                          any consumer dispute or complaint directly with the
                          Customer; (vii) you and all Transactions initiated by
                          you will comply with all applicable law, including any
                          applicable tax laws and regulations; (viii) except in
                          the ordinary course of business, no Transaction
                          submitted by you through the Service will represent a
                          sale to any principal, partner, proprietor, or owner
                          of your Entity; (viv) you will not use the Service,
                          directly or indirectly, for any fraudulent undertaking
                          or in any manner so as to interfere with the use of
                          the Service.
                        </span>
                      </p>
                      <div className="pl-6 sm:pl-10">
                        <p className="flex gap-x-5">
                          <span>10.5.</span>
                          <span className="underline">
                            Limitations of Liability
                          </span>
                        </p>
                        <div className="flex flex-col gap-y-5 mt-3 pl-8 sm:pl-12">
                          <p className="flex gap-x-5">
                            <span>10.5.1.</span>
                            <span>
                              The Service and all accompanying documentation are
                              provided on an “as is” and “as available” basis,
                              without any warranties, either express, implied,
                              or statutory, including without limitation any
                              implied warranties of title, merchantability,
                              fitness for a particular purpose, and
                              non-infringement. Use of the Service is at your
                              own risk.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>10.5.2.</span>
                            <span>
                              No advice or information, whether oral or written,
                              obtained by you from or through the Service or
                              from (i) Zbooni, Payment Processors, or any
                              relevant local financial institution; (ii) the
                              processors, suppliers, or licensors of Zbooni; or
                              (iii) any of the respective affiliates, agents,
                              directors, and employees of any of the entities
                              listed in (i) or (ii) above (collectively, the “
                              <span className="font-bold">
                                Disclaiming Entities
                              </span>
                              ” and individually a “
                              <span className="font-bold">
                                Disclaiming Entity
                              </span>
                              ”), will create any warranty. You specifically
                              acknowledge that we do not have any control over
                              the products or services that are paid for with
                              the Services, and we cannot ensure that your
                              Customers will complete a Transaction or are
                              authorized to do so.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>10.5.3.</span>
                            <span>
                              Without limiting the foregoing, the Disclaiming
                              Entities do not warrant (i) that the information
                              they provide or that is provided through the
                              Service is accurate, reliable, or correct, (ii)
                              that the Service will meet your requirements, (ii)
                              that the Service will be available at any
                              particular time or location, (iii) that the
                              Service will function uninterruptedly or be
                              secure, (iv) that any defects or errors will be
                              corrected, (v) or that the Service is free of
                              viruses or other harmful components. Any subject
                              matter downloaded or otherwise obtained through
                              the use of the Service is downloaded at your own
                              risk and you will be solely responsible for any
                              damage to your property or loss of data that
                              results from such download.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>10.5.4.</span>
                            <span>
                              The Disclaiming Entities make no representations
                              or warranties about how long will be needed to
                              complete the processing of a Transaction. The
                              Disclaiming Entities do not warrant, endorse,
                              guarantee, or assume responsibility for any
                              product or service advertised or offered by a
                              third party through the Service or any hyperlinked
                              website or service, or featured in any banner or
                              other advertising, and no Disclaiming Entity will
                              be a party to or in any way monitor any
                              Transaction between you and third-party providers
                              of products or services.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>10.5.5.</span>
                            <span>
                              In no event shall a Disclaiming Entity be liable
                              for any lost profits, loss of data, or any
                              indirect, punitive, incidental, special,
                              consequential, or exemplary damages arising out
                              of, in connection with, or relating to this
                              Agreement, Payment Processor Terms, Payment
                              Network Rules, or the Services, including without
                              limitation the use of, inability to use, or
                              unavailability of the Service. Under no
                              circumstances will any of the Disclaiming Entities
                              be responsible for any damage, loss, or injury
                              resulting from hacking, tampering, or other
                              unauthorized access or use of the Service or your
                              Zbooni Account or the information contained
                              therein.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>10.5.6.</span>
                            <span>
                              The Disclaiming Entities assume no liability or
                              responsibility for any (i) personal injury or
                              property damage, of any nature whatsoever,
                              resulting from your access to or use of the
                              Service, (ii) any unauthorized access to or use of
                              servers used in connection with the Services
                              and/or any and all personal information stored
                              therein; (iii) any interruption or cessation of
                              transmission to or from the Service; (iv) any
                              software bugs, viruses, trojan horses, or other
                              harmful code that may be transmitted to or through
                              the Service; (v) any errors, inaccuracies or
                              omissions in any content or information, for any
                              loss or damage incurred as a result of the use of
                              any content or information, in each case posted,
                              emailed, stored, transmitted, or otherwise made
                              available through the Service; and/or (vi) user
                              content or the defamatory, offensive, or illegal
                              conduct of any third party.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>10.5.7.</span>
                            <span>
                              Without limiting the foregoing provisions of this
                              Clause 10.5, the Disclaiming Entities&apos;
                              cumulative liability to you shall be limited to
                              direct damages and in all events shall not exceed
                              in the aggregate the amount of Zbooni Fees paid by
                              you to Zbooni during the three (3) month period
                              immediately preceding the event giving rise to the
                              claim for liability.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>10.5.8.</span>
                            <span>
                              This Clause 10.5 applies regardless of the legal
                              theory on which the claim is based, including
                              without limitation contract, tort (including
                              negligence), strict liability, or any other basis.
                              The limitations apply even if any Disclaiming
                              Entity has been advised of the possibility of such
                              damage.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>10.5.9.</span>
                            <span>
                              The provisions of this Clause 10.5 shall apply to
                              the fullest extent permitted by law in the
                              applicable jurisdiction.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>10.5.10.</span>
                            <span>
                              The Service is controlled and operated from its
                              facilities in the United Arab Emirates. We make no
                              representations that the Service is appropriate or
                              available for use in other locations. Those who
                              access or use the Service from other jurisdictions
                              do so at their own volition and are entirely
                              responsible for compliance with all applicable
                              United Arab Emirates, foreign and local laws and
                              regulations, including but not limited to export
                              and import regulations.
                            </span>
                          </p>
                        </div>
                      </div>
                      <div className="pl-6 sm:pl-10">
                        <p className="flex gap-x-5">
                          <span>10.6.</span>
                          <span className="underline">App Store</span>
                        </p>
                        <div className="flex flex-col gap-y-5 mt-3 pl-8 sm:pl-12">
                          <p className="flex gap-x-5">
                            <span>10.6.1.</span>
                            <span>
                              You acknowledge and agree that (i) the Agreement
                              is between you and Zbooni only, and not the app
                              store provider (“
                              <span className="font-bold">
                                App Store Provider
                              </span>
                              ”), and (ii) Zbooni is solely responsible for the
                              Zbooni App and content thereof. Your use of the
                              Zbooni App must comply with the relevant App Store
                              terms of service.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>10.6.2.</span>
                            <span>
                              You acknowledge that the App Store Provider has no
                              obligation whatsoever to furnish any maintenance
                              and support services with respect to the Zbooni
                              App.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>10.6.3.</span>
                            <span>
                              In the event of any failure of the Zbooni App to
                              conform to any applicable warranty as expressly
                              set out in this Agreement, you may notify the App
                              Store Provider, and the App Store Provider may
                              refund the purchase price for the Zbooni App (if
                              applicable) to you and to the maximum extent
                              permitted by applicable law. The App Store
                              Provider will have no other warranty obligation
                              whatsoever with respect to the Zbooni App.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>10.6.4.</span>
                            <span>
                              You and Zbooni acknowledge that, as between Zbooni
                              and the App Store Provider, the App Store Provider
                              is not responsible for addressing any claims you
                              have or any claims of any third party relating to
                              the Zbooni App or your possession and use of the
                              Zbooni App.
                            </span>
                          </p>
                          <p className="flex gap-x-5">
                            <span>10.6.5.</span>
                            <span>
                              You and Zbooni acknowledge and agree that the App
                              Store Provider and its subsidiaries, are
                              third-party beneficiaries of the Agreement as
                              related to your license of the Zbooni App, and
                              that, upon your acceptance of the Agreement, the
                              App Store Provider will have the right (and will
                              be deemed to have accepted the right) to enforce
                              the Agreement as related to your license of the
                              Zbooni App against you.
                            </span>
                          </p>
                        </div>
                      </div>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>10.7.</span>
                        <span>
                          <span className="underline">
                            Governing Law and Jurisdiction
                          </span>
                          . This Agreement shall be governed by, and construed
                          in accordance with, the laws of England & Wales
                          without reference to the conflict of laws provisions
                          thereof. Any dispute arising out of or related to this
                          Agreement that cannot be resolved by informal and
                          good-faith negotiations between the parties shall be
                          settled by final and binding arbitration to be
                          conducted by a single arbitrator in Dubai, UAE,
                          pursuant to the Rules of Arbitration of the
                          International Chamber of Commerce. The parties agree,
                          pursuant to Article 30(2)(b) of the Rules of
                          Arbitration of the International Chamber of Commerce,
                          that the Expedited Procedure Rules shall apply
                          irrespective of the amount in dispute. The language of
                          the arbitration shall be English. The decision or
                          award of the arbitrator shall be final, and judgment
                          upon such decision or award may be entered in any
                          competent court or application may be made to any
                          competent court for judicial acceptance of such
                          decision or award and an order of enforcement. The
                          parties agree that the arbitrator shall have the
                          authority to impose equitable and injunctive relief as
                          well as to award monetary relief, as the arbitrator
                          deems appropriate.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>10.8.</span>
                        <span>
                          <span className="underline">Right to Amend</span>. We
                          have the right to change or add to the terms of this
                          Agreement at any time, and to change, delete,
                          discontinue, or impose conditions on any feature or
                          aspect of the Service or software with notice that we
                          in our sole discretion deem to be reasonable in the
                          circumstances, including such notice on the Website.
                          Any use of the Service or software after our
                          publication of any such changes shall constitute your
                          acceptance of this Agreement as modified.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>10.9.</span>
                        <span>
                          <span className="underline">Assignment</span>. This
                          Agreement, and any rights and licenses granted in this
                          Agreement, may not be transferred or assigned by you
                          without our prior written consent, but may be assigned
                          by us without your consent or other restriction.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>10.10.</span>
                        <span>
                          <span className="underline">Change of Business</span>.
                          You agree to give us at least 30 days prior
                          notification of your intent to change your current
                          product or services type, your trade name, or the
                          manner in which you accept payment. You agree to
                          provide us with prompt notification if you are the
                          subject of any voluntary or involuntary bankruptcy or
                          insolvency petition or proceeding. You also agree to
                          promptly notify us of any adverse change in your
                          financial condition, any planned or anticipated
                          liquidation or substantial change in the basic nature
                          of your business, any transfer or sale of 25% or more
                          of your total assets, or any change in the control or
                          ownership of you or your parent entity. You will also
                          notify us of any judgment, writ, warrant of
                          attachment, execution, or levy against 25% or more of
                          your total assets not later than three days after you
                          obtain knowledge of it.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>10.11.</span>
                        <span>
                          <span className="underline">Parties</span>. This
                          Agreement binds you and your respective heirs,
                          representatives, and permitted and approved successors
                          (including those by merger and acquisition) or any
                          permitted assigns.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>10.12.</span>
                        <span>
                          <span className="underline">Force Majeure</span>. This
                          Agreement binds you and your respective heirs,
                          representatives, and permitted and approved successors
                          (including those by merger and acquisition) or any
                          permitted assigns.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>10.13.</span>
                        <span>
                          <span className="underline">
                            Entire Agreement and Remedies
                          </span>
                          . This Agreement constitutes the entire agreement
                          between you and Zbooni with respect to the provision
                          of the Service. Except as expressly provided in this
                          Agreement, these terms describe the entire liability
                          of Zbooni and sets forth your exclusive remedies with
                          respect to the Service and your access and use of the
                          Service. If any provision of this Agreement (or
                          portion thereof) is held to be invalid or
                          unenforceable under applicable law, then it shall be
                          changed and interpreted to accomplish the objectives
                          of such provision to the greatest extent possible
                          under applicable law, and the remaining provisions
                          will continue in full force and effect.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>10.14.</span>
                        <span>
                          You acknowledge and agree that this Agreement has been
                          reviewed by you with the benefit of independent legal
                          counsel to the extent you consider necessary and any
                          rule of construction to the effect that ambiguities
                          are to be resolved against the drafting party shall
                          not apply to the construction or interpretation of
                          this Agreement. The rights conferred upon us in this
                          Agreement are not intended to be exclusive of each
                          other or of any other rights and remedies we may have
                          at law or in equity. Rather, each and every right we
                          may have under this Agreement, at law or in equity is
                          cumulative and concurrent and in addition to every
                          other right.
                        </span>
                      </p>
                    </div>
                  </AccordionPanel>
                </Fragment>
              )}
            </AccordionContext.Consumer>
          </Accordion>
        </div>
      </div>
    </Layout>
  );
};

export default TermsAndConditions;
